module.exports = __webpack_public_path__ + "img/marketing_en.5a3ec995.png";